import { useEffect } from "react";
import { api } from "./api";

const ACTIVITY_EVENTS = ["mousemove", "mousedown", "keydown", "touchstart", "scroll", "visibilitychange"];

// Mirrors the server policy: sign out after 1h idle, and at the daily 1:00 AM (America/Toronto) cutoff.
export function useSessionGuard(user, logoutWithReason) {
  useEffect(() => {
    if (!user) return undefined;
    let idleSeconds = 3600;
    let idleTimer = null;
    let dailyTimer = null;
    let cancelled = false;
    const armIdle = () => {
      clearTimeout(idleTimer);
      idleTimer = setTimeout(() => logoutWithReason("idle"), idleSeconds * 1000);
      localStorage.setItem("pw_last_activity", String(Date.now()));
    };
    api.get("/auth/session-policy").then(({ data }) => {
      if (cancelled) return;
      idleSeconds = data.idle_seconds || 3600;
      armIdle();
      const ms = new Date(data.daily_cutoff_utc).getTime() - Date.now();
      dailyTimer = setTimeout(() => logoutWithReason("daily"), Math.max(1000, Math.min(ms, 2147000000)));
    }).catch(() => armIdle());
    const onActivity = () => {
      if (document.visibilityState === "hidden") return;
      const last = Number(localStorage.getItem("pw_last_activity") || Date.now());
      if (Date.now() - last > idleSeconds * 1000) { logoutWithReason("idle"); return; }
      armIdle();
    };
    ACTIVITY_EVENTS.forEach((ev) => window.addEventListener(ev, onActivity, { passive: true }));
    return () => {
      cancelled = true;
      clearTimeout(idleTimer); clearTimeout(dailyTimer);
      ACTIVITY_EVENTS.forEach((ev) => window.removeEventListener(ev, onActivity));
    };
  }, [user, logoutWithReason]);
}

export const SESSION_REASONS = {
  idle: "You were signed out after 1 hour of inactivity.",
  daily: "You were signed out by the daily 1:00 AM security sign-out.",
  expired: "Your session expired — please sign in again.",
};
